import styles from "./Header.module.css";
import logo from "../../assets/images/eng_logo.svg";
import Navigation from "../Navigation/Navigation.js";

const Header = () => {
  const tabs = [
    { path: "game-status", label: "Match Status" }, // 경기 현황
    { path: "game-targets", label: "Group Formation" }, // 원작대
    { path: "game-summary", label: "Match Results" }, // 경기 집계 현황
  ];

  return (
    <header className={styles.header}>
      <div className={styles.logo}>
        <img src={logo} alt="울산세계궁도대회 로고" />
      </div>
      <Navigation tabs={tabs} basePath="" variant="main" />
      <div className={styles.website}>
        <a
          href="http://xn--989a1nf0lnwar68blxat5zm15a.com/" // 울산세계궁도대회.com
          target="_blank"
          rel="noopener noreferrer"
        >
          Go to Site
        </a>
      </div>
    </header>
  );
};
export default Header;
